import { factory, getResponseCamelization } from '@repo-level/core-front';
import {
  CMSApiBase,
  CMSArrayBase,
  CMSButtonParams,
  CMSGroupParams,
  CMSImageBase,
  CMSScheduler,
  CMSOrder,
  LIMIT_500,
  buildCmsUrl,
  getResponseCMS,
} from './base';
import { CMS_URL, isCMSV3 } from 'helpers/conf';

interface IMinDepV2 {
  currency: string;
  amount: number;
}

export interface BonusI
  extends CMSArrayBase,
    CMSGroupParams,
    CMSButtonParams,
    CMSOrder,
    CMSScheduler {
  cashier: boolean;
  promoPage: boolean;
  tcPage: boolean;
  countdownToggle: boolean;
  minDepV2?: IMinDepV2[];

  title: string;
  offer: string;

  minDep: string | null;
  wager: number | null;
  frequency: string | null;
  additionalInfo: string | null;
  depNumber: string | null;
  fsAmount: string | null;
  game: string | null;
  maxBonusAmount: string | null;
  maxWinFs: string | null;
  wagerTime: string | null;

  code: string | null;
  description: string | null;
  termsAndConditions: string | null;

  background: CMSImageBase | null;
  character: CMSImageBase | null;

  limited?: boolean;
  identifier: string | null | undefined;
}

export type Bonus = CMSApiBase & BonusI;

export const bonusesV3 = factory((r) => (lang: string) =>
  r<Bonus[]>(
    'get',
    buildCmsUrl({
      path: 'bonuses-v2',
      lang,
      limit: LIMIT_500,
    })
  )
);

export const bonusesV4 = factory((r) => (lang: string) =>
  r<Bonus[]>(
    'get',
    buildCmsUrl({
      path: 'bonuses-v-2-s',
      lang,
      limit: LIMIT_500,
      additionalParams: { populate: 'deep' },
    }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const bonuses = isCMSV3 ? bonusesV3 : bonusesV4;

export type BonusGroupItem = Omit<
  BonusI,
  'background' | 'character' | 'title'
> & {
  isActive?: boolean;
};

export interface BonusGroup
  extends CMSApiBase,
    CMSGroupParams,
    CMSScheduler,
    CMSOrder {
  title: string;
  offer: string;
  identifier: string | null | undefined;
  bonuses: BonusGroupItem[];
  background: CMSImageBase | null;
  character: CMSImageBase | null;
}

export type BonusItemGeneral = BonusI | BonusGroupItem;

export const bonusGroupsV3 = factory((r) => (lang: string) =>
  r<BonusGroup[]>('get', `${CMS_URL}/bonus-groups-v2?_locale=${lang}`)
);

export const bonusGroupsV4 = factory((r) => (lang: string) =>
  r<BonusGroup[]>(
    'get',
    buildCmsUrl({
      path: 'bonus-groups-v-2-s',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const bonusGroups = isCMSV3 ? bonusGroupsV3 : bonusGroupsV4;
